import React from 'react';
import { Col, Row, Tag } from 'antd';
import { getMargin, getMarginTagColor } from '@gtintel/platform-utils';
import * as S from '../styles';
const PricingDetail = ({
  projectDetail,
  showAdjustmentModal
}) => {
  const projectMargin = getMargin(+projectDetail?.partner_price, +projectDetail?.final_price);
  return <S.PricingDetail>
      <Row>
        <Col md={12}>
          <S.Label>Original Partner Price</S.Label>
          <div>{`${projectDetail?.currency_display} ${projectDetail?.currency}${projectDetail?.partner_price}`}</div>
        </Col>
        <Col md={12}>
          <S.Label>Original Client Price</S.Label>
          <div>{`${projectDetail?.currency_display} ${projectDetail?.currency}${projectDetail?.final_price}`}</div>
        </Col>
        <Col md={12}></Col>
      </Row>
      {projectDetail.status != '1' && projectDetail.status != '3' && <Row>
          <a onClick={showAdjustmentModal}>Adjustments</a>
        </Row>}
      <Row>
        <Tag color={getMarginTagColor(projectMargin)} key={projectMargin}>
          {(projectMargin * 100).toFixed(1)}%
        </Tag>
      </Row>
    </S.PricingDetail>;
};
export default PricingDetail;